import type { TierId } from "./partner";

/**
 * Package tier — the catalog entry a partner's entitlements derive from.
 * See `./partner.ts` for the note on replacing these with generated
 * schema types once `customer-portal-services` exists.
 */

/** Available regions; also the source of the RegionKey type. */
export const REGIONS = ["US", "UK", "Canada", "Netherlands", "France", "Spain"] as const;

export type RegionKey = (typeof REGIONS)[number];

export interface Tier {
  id: TierId;
  name: string;
  savedCap: number;
  adhocCap: number;
  /** Max query length, in characters. */
  queryLen: number;
  /** Which content regions this tier includes. */
  regions: Record<RegionKey, boolean>;
}
